/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountMustBeGreaterThanZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CantRenounceOwnerRole",
        type: "error",
    },
    {
        inputs: [],
        name: "ContractAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToGetAssetDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "interestAccrued",
                type: "uint256",
            },
        ],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "UnauthorizedBeneficiary",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Donate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "InterestWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "representationToken",
                type: "address",
            },
        ],
        name: "RepresentationTokenSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amountMinted",
                type: "uint256",
            },
        ],
        name: "Supply",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "XUnityTrinityAavePoolInitialized",
        type: "event",
    },
    {
        inputs: [],
        name: "ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BENEFICIARY_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "donate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAvailableInterest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMembers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unity",
                type: "address",
            },
            {
                internalType: "address",
                name: "_aavePool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_yieldToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "representationToken",
        outputs: [
            {
                internalType: "contract IERC20Mintable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_representationToken",
                type: "address",
            },
        ],
        name: "setRepresentationToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "supply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unityToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "withdrawAvailableInterest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "yieldToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class XUnityTrinityAave__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
XUnityTrinityAave__factory.bytecode = _bytecode;
XUnityTrinityAave__factory.abi = _abi;
//# sourceMappingURL=XUnityTrinityAave__factory.js.map